module.exports = __webpack_public_path__ + "static/media/Kirk_Larsen_2026_Logo.18a736c8.png";